module.exports = __webpack_public_path__ + "img/service.631e2095.png";